export default __webpack_public_path__ + "static/image-1-9ac53eec2cee9fe4461388c6662aa506.jpg";